import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=de15c920&"
import script from "./modal.ts?vue&type=script&lang=ts&"
export * from "./modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports